import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import { useNotification } from "~hooks/useNotification";
import type { Notification, NotificationResponse } from "~types/notification.ts";

export const useMarkAsReadNotifications = () => {
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  return useMutation<NotificationResponse, Error>({
    mutationFn: async () => {
      return await request(`notifications/mark-as-read`, { method: "POST" });
    },
    onSuccess: (response: NotificationResponse) => {
      queryClient.setQueryData(["notifications"], (_?: Notification[]) => response.data || []);
      refetchUserUpdates();
      notification.success({
        message: formatMessage({ id: "notificationsPage.markAsRead.success" }),
        placement: "bottomRight",
      });
    },
  });
};
